<div class="relative" *transloco="let t" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="closeDialog()" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>

	<label id="example-radio-group-label" class="block cursor-move pr-12 pt-2" cdkDragHandle>{{ t('appendixDialog.title') }}</label>
	<mat-radio-group [(ngModel)]="selectedAppendixOption" aria-labelledby="example-radio-group-label" class="example-radio-group">
		@for (option of appendixOptions; track option) {
			<mat-radio-button [value]="option" class="example-radio-button">
				{{ t('appendixDialog.' + option) }}
			</mat-radio-button>
		}
	</mat-radio-group>

	<div mat-dialog-actions>
		<button (click)="doAction()" color="primary" mat-raised-button>{{ t('commonActions.save') }}</button>
	</div>
</div>
